export default "__VITE_ASSET__$PKZYYjm__"